import React from 'react';
import { FILTERED_DOCUMENT_SELECTION_FILTERS, FilteredDocumentsSelection } from './FilteredDocumentsSelection';
import { FilterableDocumentsContextProvider } from '@/contexts/FilterableDocumentsContext';
import { FormStateContext } from '@/contexts/FormStateContext';
import { fetchDocumentsForTags, fetchNewsDocumentsForTags } from '@utils/doc';

export const CompanyDocumentSelection = ({ singleDocMode = false }) => {
  const { state: formState } = React.useContext(FormStateContext);
  const [initializing, setInitializing] = React.useState(true);

  const docGetter = async () => {
    if (formState.tags.length === 0) {
      setInitializing(false);
      return null;
    }
    const [companyDocs, newsDocs] = await Promise.all([
      fetchDocumentsForTags(formState.tags),
      fetchNewsDocumentsForTags(formState.tags),
    ]);
    setInitializing(false);
    return [...(companyDocs || []), ...(newsDocs || [])];
  };

  return (
    <FilterableDocumentsContextProvider docGetter={docGetter}>
      <FilteredDocumentsSelection
        singleDocMode={singleDocMode}
        filterModes={[
          FILTERED_DOCUMENT_SELECTION_FILTERS.tags,
          FILTERED_DOCUMENT_SELECTION_FILTERS.documentTypes,
          FILTERED_DOCUMENT_SELECTION_FILTERS.reportingPeriods,
        ]}
        initializing={initializing}
      />
    </FilterableDocumentsContextProvider>
  );
};
